import styled from "styled-components";
import { imgs } from "../constants/imgConst";
import { CommonLayout } from "../style/common";
import { flexColumn, flexColumnCenterCenter } from "../style/mixins";
import { theme } from "../theme";
import { useNavigate } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAlertStore } from "../store/alertStore";
import { useMemberStore } from "../store/memberStore";
import { memberLogin } from "../api/member";

export default function Login() {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormInputs>();
  const setAlert = useAlertStore((state) => state.setAlert);
  const { setMember } = useMemberStore();
  
  const onSubmit: SubmitHandler<LoginFormInputs> = async (data) => {
    const { id, pw } = data;
    const loginData = { member_type: 0, member_id: id, member_pw: pw };

    try {
      const response = await memberLogin(loginData);
      const levelToLink = response.data.member_permit_level >= 100 ? "/dashboard" : "/notice";
    //   if (100 > response.data.member_permit_level) {
    //     memberLogout("#");
    //     setAlert("접근 권한이 없습니다.", "red");
    //   } else {
        setMember(response.data);
        navigate(levelToLink);
    //   }
    } catch (error) {}
  };

  const onError = () => {
    if (errors.id) {
      setAlert(errors.id.message || "아이디를 입력해주세요.", "red");
    } else if (errors.pw) {
      setAlert(errors.pw.message || "비밀번호를 입력해주세요.", "red");
    }
  };

  return (
    <LoginLayout $bgImg={imgs.loginBg}>
      <LoginLogo src={imgs.loginLogo} alt="로고" />

        <LoginInputBox onSubmit={handleSubmit(onSubmit, onError)}>
          <input
              type="text"
              placeholder="아이디"
              {...register("id", { required: "아이디를 입력해주세요." })}
            />
            <input
              type="password"
              placeholder="비밀번호"
              {...register("pw", { required: "비밀번호를 입력해주세요." })}
            />
            <button type="submit">로그인</button>
        </LoginInputBox>
    </LoginLayout>
  );
}

const LoginLayout = styled(CommonLayout)<{ $bgImg: string; }>`
  background-image: ${({ $bgImg }) => `url(${$bgImg})`};
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  ${flexColumnCenterCenter};
`;

const LoginLogo = styled.img`
  width: 212px;
  margin-bottom: 1rem;
`;

const LoginInputBox = styled.form`
  background-color: #fff;
  width: 316px;
  padding: 2.25rem 1.875rem;
  border: 1px solid #C7C7C7;
  border-radius: 0.25rem;
  ${flexColumn};
  gap: 0.5rem;

  input {
    color: #929292;
    font-size: 0.875rem;
    font-weight: 400;
    background-color: #F2F9FF;
    width: 100%;
    height: 46px;
    padding-left: 20px;
    border: 1px solid #cccccc;
    border-radius: 0.375rem;
    margin-bottom: 0;

    /* &:first-child {
      border-radius: 6px 6px 0 0;
    }

    &:nth-child(2) {
      border-radius: 0 0 6px 6px;
    } */
  }

  button {
    color: #FFF;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.32px;
    background-color: ${theme.color.primary};
    width: 100%;
    height: 52px;
    border-radius: 0.25rem;
    margin: 0.5rem 0 0;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      background-color: ${theme.hoverColor.primary};
    }
  }
`;